import { CanActivate, Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthenticationService } from './authentication.service';
import { Const } from '@app/shared';

@Injectable()
export class PermissionsGuard implements CanActivate {

  constructor(
    private router: Router,
    private as: AuthenticationService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    let activateAccess = false;
    switch (state.url) {
      case '/administration':
        const credentials = this.as.getCredentials();
        if (credentials.permisos && credentials.permisos.length) {
          for (const permission of credentials.permisos) {
            if (
              permission.permiso === Const.types_permissions.administrationForms ||
              permission.permiso === Const.types_permissions.administrationGroupsPermissions ||
              permission.permiso === Const.types_permissions.administrationHoliDays ||
              permission.permiso === Const.types_permissions.administrationMasterTables ||
              permission.permiso === Const.types_permissions.administrationProcess ||
              permission.permiso === Const.types_permissions.administrationProcessBasic ||
              permission.permiso === Const.types_permissions.administrationUtilities ||
              permission.permiso === Const.types_permissions.administrationReports ||
              permission.permiso === Const.types_permissions.administrationDocument ||
              permission.permiso === Const.types_permissions.administrationSystem
            ) {
              activateAccess = true;
              break;
            }
          }
        } else {
          this.router.navigate([this.router.url]);
          return false;
        }
        break;
      case '/administration/forms-creaction':
        if (this.as.confirmPermission(Const.types_permissions.administrationForms)) {
          activateAccess = true;
        } else {
          this.router.navigate([this.router.url]);
          return false;
        }
        break;
      case '/administration/groups-permissions':
        if (this.as.confirmPermission(Const.types_permissions.administrationGroupsPermissions)) {
          activateAccess = true;
        } else {
          this.router.navigate([this.router.url]);
          return false;
        }
        break;
      case '/administration/special-days':
        if (this.as.confirmPermission(Const.types_permissions.administrationHoliDays)) {
          activateAccess = true;
        } else {
          this.router.navigate([this.router.url]);
          return false;
        }
        break;
      case '/administration/master':
        if (this.as.confirmPermission(Const.types_permissions.administrationMasterTables)) {
          activateAccess = true;
        } else {
          this.router.navigate([this.router.url]);
          return false;
        }
        break;
      case '/administration/process-automation':
        if (this.as.confirmPermission(Const.types_permissions.administrationProcess)) {
          activateAccess = true;
        } else {
          this.router.navigate([this.router.url]);
          return false;
        }
        break;
      case '/administration/basic-process-configuration':
          if (this.as.confirmPermission(Const.types_permissions.administrationProcessBasic)) {
            activateAccess = true;
          } else {
            this.router.navigate([this.router.url]);
            return false;
          }
          break;
      case '/administration/utilitarios-management':
        if (this.as.confirmPermission(Const.types_permissions.administrationUtilities)) {
          activateAccess = true;
        } else {
          this.router.navigate([this.router.url]);
          return false;
        }
        break;
      case '/administration/reports':
        if (this.as.confirmPermission(Const.types_permissions.administrationReports)) {
          activateAccess = true;
        } else {
          this.router.navigate([this.router.url]);
          return false;
        }
        break;
      case '/administration/system-management':
        if (this.as.confirmPermission(Const.types_permissions.administrationSystem)) {
          activateAccess = true;
        } else {
          this.router.navigate([this.router.url]);
          return false;
        }
        break;
      case '/administration/documents':
        if (this.as.confirmPermission(Const.types_permissions.administrationDocument)) {
          activateAccess = true;
        } else {
          this.router.navigate([this.router.url]);
          return false;
        }
        break;
        case '/administration/publications-management':
          if (this.as.confirmPermission(Const.types_permissions.administrationPublications)) {
            activateAccess = true;
          } else {
            this.router.navigate([this.router.url]);
            return false;
          }
          break;
        case '/administration/iframe-management':
          if (this.as.confirmPermission(Const.types_permissions.administrationIframes)) {
            activateAccess = true;
          } else {
            this.router.navigate([this.router.url]);
            return false;
          }
          break;
        case '/administration/system-users-inactivation':
          if (this.as.confirmPermission(Const.types_permissions.administrationGroupsPermissions)) {//Cambiar permiso
            
            activateAccess = true;
          } else {
            this.router.navigate([this.router.url]);
            return false;
          }
          break;
        case '/administration/help-management':
            if (this.as.confirmPermission(Const.types_permissions.adminHelps)) {
              activateAccess = true;
            } else {
              this.router.navigate([this.router.url]);
              return false;
            }
            break;
        case '/administration/consecutive-act-management':
              if (this.as.confirmPermission(Const.types_permissions.adminConsecutiveAct)) {
                activateAccess = true;
              } else {
                this.router.navigate([this.router.url]);
                return false;
              }
              break;
    }
    if (activateAccess) {
      return true;
    } else {
      this.router.navigate([this.router.url]);
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/authentication/permissions.guard.ts